import { render, staticRenderFns } from "./NextConferenceView.vue?vue&type=template&id=d2177af8&"
import script from "./NextConferenceView.vue?vue&type=script&lang=js&"
export * from "./NextConferenceView.vue?vue&type=script&lang=js&"
import style0 from "./NextConferenceView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports